import { render, staticRenderFns } from "./ProgressBarAuthenticated.vue?vue&type=template&id=60fe87f0"
import script from "./ProgressBarAuthenticated.vue?vue&type=script&lang=js"
export * from "./ProgressBarAuthenticated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports